import React, { Component } from 'react';
import {
  FormControl,
  ListGroup
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import './search.css';

class SearchComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: props.results,
      value: ''
    };
    this.onTextChange = this.onTextChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.parseResults = this.parseResults.bind(this);
  }

  onTextChange(e) {
    e.preventDefault();
    const { value } = e.target;
    this.setState({value});
    return this.props.onTextChange(value);
  }

  onSelect(e, i) {
    e.preventDefault();
    this.setState({value: ''});
    if (this.props.onSelect !== undefined) this.props.onSelect(i);
  }

  parseResults() {
    return (
      <ListGroup className="search-results">
        { this.props.results.map((r, i) => <ListGroup.Item key={i} onClick={e => this.onSelect(e, i)}>{r}</ListGroup.Item>)}
      </ListGroup>
    );
  }

  render() {
    const results = this.props.results && this.props.results.length > 0 ? this.parseResults() : null;
    const placeholder = this.props.placeholder !== null ? this.props.placeholder : "Search";

    return (
      <div>
        <FormControl type="text" placeholder={ placeholder } value={this.state.value} className="mr-sm-2" onChange={this.onTextChange}/>
        { results }
      </div>
    );
  }
}

SearchComponent.propTypes = {
  placeholder: PropTypes.string,
  results: PropTypes.arrayOf(PropTypes.string),
  onTextChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func
};

export default SearchComponent;
